import moment from 'moment';
import { ExportService, FILE_TYPE } from "../ExportService";
import { REPORT_TYPE } from "../../../components/report/ReportModalController";
import { MT94X, transactions, FILTER, accounts } from '../../arsweb/RoutingPaths';

/** @ngInject */
export class MT94XService extends ExportService {
    constructor(ArsConfig, userService) {
        super(ArsConfig, userService);
    }

    route(controller) {
        return this.isGroupUrl(controller.restUrl) ? accounts : controller.restUrl;
    }

    /**
     * Download the MT940 file
     * @param controller
     * @param selectedElements: omitted when the filter is used (group cases)
     * @returns {*}
     */
    downloadMT94X(controller, selectedElements, params) {
        const reportType = params.reportType;
        const service = this.getService(controller);

        // Set the message type (MT940/MT942) and the file prefix
        const body = {
            type: reportType.type,
            title: reportType.type.toLowerCase() + '_' + moment(new Date()).format('DDMMYYYY_HHmm'),
            tag61: params.tag61,
            withFullText: params.withFullText,
            tag28withC: params.tag28withC,
            header: params.header,
            withDefaultTransactionReference: params.withDefaultTransactionReference,
            lastStatement: params.lastStatement,
            unRead: params.unRead,
            mt999Footer: params.mt999Footer,
            deliveriesWithoutTransactions: params.deliveriesWithoutTransactions,
            tag64AlwaysAvailable: params.tag64AlwaysAvailable,
            forwardTag65: params.forwardTag65,
            statementNo: params.statementNo,
            trBookingDate: params.trBookingDate
        };

        // Date Range (account level)
        this.createReportFilter(service, params);

        // ARSWEB-416: Transactions are not selectable
        if (REPORT_TYPE.MT940_TRANSACTIONS === reportType || REPORT_TYPE.MT940_ACTUAL_STATEMENT === reportType ||
            REPORT_TYPE.MT942_ACTUAL_INTRADAY === reportType) {

            // keep the statementID: /accounts/statements/123456
            controller.promise = service.postUserReport(MT94X + controller.restUrl.replace(transactions, ''), body)
                .then((data) => this.downloadFile(data, body.title, FILE_TYPE.TXT, controller, service, body));
            return;
        }

        // Group or select all cases: we use a filter to get the items (accounts, statements)
        if (!selectedElements) {
            if (controller.masterRowCount) {
                this.total = controller.masterRowCount;
                this.download(controller, service, body);
            } else {
                this.checkTotalElements(service, controller.restUrl).then(() =>
                    this.download(controller, service, body));
            }
            return;
        }

        // Selection cases: we use the selected items for the query
        if (selectedElements.length === 0) {
            controller.infoPop('NO_ROW_SELECTED');
            return;
        }

        body.ids = selectedElements;
        body.from = params.dateRange ? params.dateRange.lowerBound : null;
        body.to = params.dateRange ? params.dateRange.upperBound : null;
        body.lastStatement = params.lastStatement;
        body.unRead = params.unRead;

        controller.promise = service[FILE_TYPE.TXT.userFunction](MT94X + this.route(controller), body)
            .then((data) => this.downloadFile(data, body.title, FILE_TYPE.TXT, controller, service, body));
    }

    download(controller, service, body) {
        controller.promise = service.postUserReport(MT94X + this.route(controller) + FILTER, body)
            .then((data) => this.downloadFile(data, body.title, FILE_TYPE.TXT, controller, service, body))
            .then(() => this.resetFilter(controller, service));
    }
}
